<div id="simple-page">
  <main>
    <div class="wrapper">
      <h1>Your Community access has ended</h1>
      <p>
        Learn more about what HUNTER Premium can do for you and your
        organization.
      </p>

      <div class="premium-container">
        <h2>HUNTER Premium</h2>
        <p>
          Elevate your threat hunting workbench with access to exclusive content
          and capabilities available only with HUNTER Premium.
        </p>
        <div class="points">
          <div class="point">
            <i class="k-icon k-font-icon k-i-check k-color-primary"></i>
            <div>
              Gain unrestricted access to Premium Hunt Packages for all security
              tools.
            </div>
          </div>
          <div class="point">
            <i class="k-icon k-font-icon k-i-check k-color-primary"></i>
            <div>
              Complete access to the hunt packages included in the Emerging
              Threats Collections.
            </div>
          </div>
          <div class="point">
            <i class="k-icon k-font-icon k-i-check k-color-primary"></i>
            <div>
              Direct line of communication with the Intel 471 Threat Hunt team
              via the Hunt Package Feedback Feature.
            </div>
          </div>
          <div class="point">
            <i class="k-icon k-font-icon k-i-check k-color-primary"></i>
            <div>
              Access to Threat Hunt Syncs with Intel 471 Threat Hunters as a
              part of the Customer Success Program.
            </div>
          </div>
          <div class="point">
            <i class="k-icon k-font-icon k-i-check k-color-primary"></i>
            <div>
              To plan, execute, report and manage the Hunt Packages, ask about
              access to the HUNTER Hunt Module.
            </div>
          </div>
        </div>
        <cyborg-button color="primary" (click)="talkToCyborg()"
          >Talk to Intel 471</cyborg-button
        >
      </div>
      <p (click)="openDialog()" class="reactivate">
        No thanks, just reactivate my Community access...
      </p>
    </div>
  </main>
</div>
